import type { JamRegistrationStatus } from "@/server/platform/db/schema/jam-registrations";

const ALLOWED: Record<JamRegistrationStatus, JamRegistrationStatus[]> = {
  pending: ["contacted", "rejected", "duplicate"],
  contacted: ["pending", "confirmed", "rejected", "duplicate"],
  confirmed: ["pending", "converted", "rejected"],
  rejected: [],
  duplicate: ["pending", "contacted", "confirmed"],
  converted: [],
};

export function canTransitionJamRegistrationStatus(
  from: JamRegistrationStatus,
  to: JamRegistrationStatus,
): boolean {
  if (from === to) return true;
  return ALLOWED[from]?.includes(to) ?? false;
}

export const JAM_CLAIMED_STATUSES: JamRegistrationStatus[] = [
  "pending",
  "contacted",
  "confirmed",
  "converted",
];
